export { AnimatedText, Text, TextVariant } from './Text';
